import { jsx as _jsx } from "react/jsx-runtime";
import miscAssetGenerator from "../../assets/misc_asset_generator.svg";
const sizeMap = {
    lg: "w-8 h-8",
    md: "w-6 h-6",
    sm: "w-4 h-4",
    xl: "w-12 h-12"
};
export const CatGeneratorIcon = ({ className = "", size = "xl" }) => (_jsx("img", { alt: "Generator", className: `${sizeMap[size] ?? sizeMap.xl} mx-auto ${className}`, "data-test": "generator-icon", src: miscAssetGenerator }));
